import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Divider from 'app/components/bibs/shared/Divider';
import { ExpandableText } from '@bibliocommons/expandable';
import { catalogBibShape, ugcCommentShape, paginationShape } from '@bibliocommons/bc-prop-types';
import CommentDisplayContainer from 'app/components/bibs/shared/ugc/CommentDisplay';
import { ContentWarningPanelContainer } from 'app/components/bibs/shared/ugc/ContentWarningPanel';
import { CommentEditorContainer } from 'app/components/bibs/shared/ugc/CommentEditor';
import UgcList from 'app/components/bibs/shared/ugc/UgcList';
import BibSubPage from 'app/components/bibs/subpages/BibSubPage';
import './AllCommentsPage.scss';

export class AllCommentsPage extends React.PureComponent {
  componentDidMount() {
    this.fetchRelationships();
  }

  componentDidUpdate(prevProps) {
    if (!this.props.userIds.equals(prevProps.userIds)) {
      this.fetchRelationships();
    }
  }

  fetchRelationships() {
    const { currentUserId, relationshipsActions, userIds } = this.props;

    if (currentUserId && userIds.size) {
      relationshipsActions.getRelationships({ userId: currentUserId, userIds });
    }
  }

  handleSuccess = () => {
    const metadataId = this.props.catalogBib.get('metadataId');
    this.props.commentsActions.getComments({ metadataId });
  };

  renderEditor = () => {
    const { catalogBib, currentUserComments, ugcEditorActions } = this.props;

    // If current user hasn't submitted a comment for this bib, render a comment editor
    // Current user's comment will always be first in the list of comments
    return (
      !currentUserComments.get(catalogBib.get('metadataId')) && (
        <CommentEditorContainer
          catalogBib={catalogBib}
          handleCancel={() => ugcEditorActions.closeEditor('comment')}
          handleSuccess={this.handleSuccess}
        />
      )
    );
  };

  renderComment = comment => {
    return (
      <CommentDisplayContainer
        comment={comment}
        catalogBib={this.props.catalogBib}
        handleDeleteSuccess={this.handleSuccess}
      >
        <ExpandableText
          text={comment.get('comment')}
          truncateCount={240}
          expandLinkHref={`#read-more-ugc-display-${comment.get('id')}`}
          textKey="comment"
        />
      </CommentDisplayContainer>
    );
  };

  render() {
    const { catalogBib, comments, pagination, isFetching } = this.props;

    return (
      <div className="cp-all-comments-page">
        <BibSubPage catalogBib={catalogBib} headerLocKey="comments" pagination={pagination} isFetching={isFetching}>
          <UgcList
            items={comments}
            pagination={pagination}
            catalogBib={this.props.catalogBib}
            transactions={this.props.commentsTransactions}
            renderItem={this.renderComment}
            renderEditor={this.renderEditor}
            contentType="community_comments"
            ugcType="comments"
            showDisclaimer
          >
            <Divider />
            <ContentWarningPanelContainer />
          </UgcList>
        </BibSubPage>
      </div>
    );
  }
}

AllCommentsPage.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  comments: ImmutablePropTypes.listOf(ugcCommentShape).isRequired,
  currentUserComments: ImmutablePropTypes.mapOf(ugcCommentShape).isRequired,
  currentUserId: PropTypes.number,
  commentsTransactions: ImmutablePropTypes.map.isRequired,
  pagination: paginationShape.isRequired,
  ugcEditorActions: PropTypes.objectOf(PropTypes.func).isRequired,
  commentsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  isFetching: PropTypes.bool,
  relationshipsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  userIds: ImmutablePropTypes.listOf(PropTypes.number).isRequired
};

export default AllCommentsPage;
